import { render, staticRenderFns } from "./direct-message.vue?vue&type=template&id=9d072424&scoped=true&lang=pug"
import script from "./direct-message.vue?vue&type=script&lang=ts"
export * from "./direct-message.vue?vue&type=script&lang=ts"
import style0 from "./direct-message.vue?vue&type=style&index=0&id=9d072424&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d072424",
  null
  
)

export default component.exports